export default function(o, done){

  o.iphoneNavbarFix = function(){
    if(window.navigator.userAgent.match(/iPhone/i)){
      // console.log('iphoneNavbarFix iphone detected')
      if(window.innerHeight < 326) {
        // console.log('iphoneNavbarFix navbar detected')
        if($('.iphoneNavbarFixBottom').length){
          var paddingBottom = 50 - $(window).scrollTop() + 'px'
          // console.log('iphoneNavbarFix add paddingBottom to bottom elements')
          $('.iphoneNavbarFixBottom').css({
            paddingBottom: paddingBottom,
          })
        }
        if($('.iphoneNavbarFixTop').length){
          console.log('iphoneNavbarFix add padding to top e')
          var paddingTop = $(window).scrollTop() + 'px'
          $('.iphoneNavbarFixTop').css({
            paddingTop: paddingTop,
          })
        }
      } else {
        if($('.iphoneNavbarFixBottom').length){
          $('.iphoneNavbarFixBottom').css({
            paddingBottom: '',
          })
        }
        if($('.iphoneNavbarFixTop').length){
          $('.iphoneNavbarFixTop').css({
            paddingTop: '',
          })
        }
      }
    }
  }

  o.currentOrientation = window.orientation

  $(window).on('resize', _.debounce(function() {

    if (o.currentOrientation != window.orientation){
      o.currentOrientation = window.orientation
      if(o.gridDiv && o.gridDiv.is(':visible')){
        updateSizes()
        o.gridDiv.resize()
      }
    }

    console.log('resize')
    o.iphoneNavbarFix()
    updateSizes()

  }, 500))

  $(window).on('scroll', _.debounce(function() {
    o.iphoneNavbarFix()
  }, 500))

  document.addEventListener('mousemove', function(e){
    o.currentMouseX = e.clientX
    o.currentMouseY = e.clientY
  })

  var html =
    $('html')
    .css({
      fontSize: o.fontSize,
    })

  o.autoHideTime = 5000

  o.viewDiv =
    $('<div>')

  if(o.store('role') == 'admin'){
    var backgroundFile = 'omb-background-noise-1080.gif'
  } else {
    var backgroundFile = 'omb-background-noise-720.gif'
  }

  var server = o.util.getUrl('asset')

  var backgroundUrl = `${server}${backgroundFile}`

  o.backgroundDiv =
    $('<div>')
    .css({
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      height: '100%',  
      background: `url(${backgroundUrl})`,
      backgroundSize: 'cover',
    })

  o.body =
    $('body')
    .css({
      fontFamily: 'Helvetica Neue LT W06_85 Heavy',
      textShadow: '0 0.1rem 0.2rem rgba(0,0,0,0.50)',
      textTransform: 'uppercase',
      color: o.colors.yellow,
      // backgroundColor: "black",
      height: "100%",
      width: '100%',
      overflow: 'hidden',
      lineHeight: '1.2em',
    })
    .append([
      o.backgroundDiv,
    ])

  o.fontSizeDef = {
    xs: "0.7rem",
    s: "0.85rem",
    m: "1.4rem",
    l: "1.8rem",
    xl: "2.8rem",
  }

  o.morePagesTextCss = {
    maxWidth: '34rem',
    margin: '0 auto',
    marginTop: '1.4rem',
    marginBottom: '3.9rem',
    fontSize: o.fontSizeDef.xs,
    lineHeight: '1.1rem',
    textAlign: 'center',
    padding: '0 1.5rem',
  }

  o.mainDivCss = {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: '100%',
  }

  var updateSizes = function(){
  
    var w = $('body').width()
  
    // phone
    if(w <= 375){
      o.fontSize = '16px'
      o.screenSize = 1

    // tablet
    } else if(w <= 768){
      o.fontSize = '19px'
      o.screenSize = 2
    } else if (w <= 1024) {
      o.fontSize = '19px'
      o.screenSize = 3

    // desktop small
    } else if (w <= 1281) {
      o.fontSize = '23px'
      o.screenSize = 4

    // desktop big
    } else if (w <= 1441) {
      o.fontSize = '26px'
      o.screenSize = 5
    } else if (w <= 1680) {
      o.fontSize = '27px'
      o.screenSize = 6

    // tv
    } else {
      o.fontSize = '30px'
      o.screenSize = 7
    }

    $('html').css({fontSize: o.fontSize})

  }

  updateSizes()

  $('<style type="text/css"></style>')
  .append(`a {color: ${o.colors.yellow};}`)
  .append(`a {text-decoration: none;}`)
  .append(`a:hover {color: ${o.colors.red};}`)
  .append(`.red {color: ${o.colors.red};}`)
  .append(`.highlighted {color: ${o.colors.red} !important;}`)
  .append(`.notHighlighted {color: ${o.colors.yellow} !important;}`)
  .append(`.visited {color: ${o.colors.red} !important;}`)
  .append('::-webkit-scrollbar { display: none; }')
  .append('::-webkit-input-placeholder { color: black; }')
  .append('::placeholder { color: rgba(0,0,0,0.9); }')
  .append('* { -webkit-user-select: none; }')
  .appendTo('head')

  done()

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/app/setup.js